var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({staticClass:"ma-0 pa-0",attrs:{"value":_vm.value,"error-messages":_vm.errors,"label":_vm.label,"placeholder":_vm.$t(
        'demande.formulaires.champs.courriel-approbateur-departement.placeholder'
      )},on:{"change":_vm.onValueChange}},'v-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }